export default "/images/f0736978e70db171525c781b728282be.avif";